import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { revokeUserSessions, type UserSummary } from "../lib/api";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";

type Props = {
  user: UserSummary | null;
  onClose: () => void;
};

export function UserSessionsDialog({ user, onClose }: Props) {
  const revoke = useMutation({
    mutationFn: () => {
      if (!user) throw new Error("no user");
      return revokeUserSessions(user.id);
    },
    onSuccess: () => {
      toast.success("Alle Sessions widerrufen");
      onClose();
    },
    onError: () => toast.error("Konnte Sessions nicht widerrufen"),
  });

  return (
    <Dialog open={user !== null} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Sessions widerrufen</DialogTitle>
          <DialogDescription>
            {user ? user.email : ""} wird beim nächsten Request ausgeloggt
            und muss sich neu anmelden.
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm">
          Dies widerruft alle aktiven Sessions dieses Users (Force-Logout).
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Abbrechen
          </Button>
          <Button
            variant="destructive"
            onClick={() => revoke.mutate()}
            disabled={revoke.isPending}
          >
            {revoke.isPending ? "…" : "Alle Sessions widerrufen"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
